/* SawaKart product page (theme only). Loaded on product and article templates (snippets/sk-head.liquid).

   - SK Product section (sections/sk-product.liquid) = staging's product detail page: photo gallery
     (thumbnails, arrows, crossfade + hover zoom on desktop; swipe + dots on phones), variant picker,
     price / sale badge, quantity, "Add to Cart — $total", the phone's sticky bar. Choosing a variant
     (photo tiles / pills) shows its photo, showing a photo of a variant chooses that variant (keeping
     the other options when it can), and hovering a tile previews its photo. The URL follows the
     variant (?variant=). Add to cart goes through SK.cart.add (sk-core.js), which opens the cart
     sidebar; without it the form posts to /cart/add as usual. Arrow keys in the picker: SK.radioKeys
     (sk-quick-add.js). Data: <script data-skp-json> (options; per variant: options, price, compare,
     media, photo).
   - Tabs Description | Reviews (arrow keys; #reviews and Judge.me's #judgeme_product_reviews open
     Reviews). Reviews = Judge.me's app block inside the section: its numbers (average, count, 5 -> 1
     breakdown) fill our summary, stars and the rating line under the title; our form is written in
     place and sent like Judge.me's own (POST api.judge.me/api/v1/reviews, multipart, no secret key).
   - Empire's product section (disabled in templates/product.json, kept for rollback): the same photo ->
     variant link on its Swiper gallery, through its radios / selects
     (<script data-sk-variant-media> in snippets/product.liquid).
   - Instagram share button (snippets/share-buttons.liquid): Instagram has no share link for websites,
     so phones get the system share menu (Instagram is in it) and computers get the link copied. */
(function () {
  'use strict';
  window.SK = window.SK || {};
  if (window.SK.productPage) return;
  window.SK.productPage = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_QTY = 999;

  function money(cents) {
    var text = window.SK.formatMoney ? window.SK.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
    return String(text).replace(/^\$\s+/, '$');
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  /* ================= SK Product section ================= */

  function initProduct(root) {
    if (root.skReady) return;
    var dataEl = root.querySelector('script[data-skp-json]');
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    root.skReady = true;

    var variants = data.variants || [];
    var form = root.querySelector('[data-skp-form]');
    var idInput = root.querySelector('[data-skp-id]');
    var qtyInput = root.querySelector('[data-skp-qty-input]');
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    if (!current) return;
    var selected = current.options.slice();
    var qty = 1;
    var busy = false;
    var addedTimer = 0;

    /* ---------- variants ---------- */

    function matches(v, opts) {
      for (var i = 0; i < opts.length; i++) if (v.options[i] !== opts[i]) return false;
      return true;
    }

    function exact(opts) {
      return variants.filter(function (v) { return matches(v, opts); })[0] || null;
    }

    // The variant with `value` at option `index` that keeps most of the other chosen options.
    function closest(index, value) {
      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[index] !== value) return;
        var score = 0;
        v.options.forEach(function (o, i) { if (o === selected[i]) score += 2; });
        if (v.available) score += 1;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }

    function chooseOption(index, value) {
      var opts = selected.slice();
      opts[index] = value;
      var v = exact(opts) || closest(index, value);
      if (v) applyVariant(v, {});
    }

    function applyVariant(v, opts) {
      current = v;
      selected = v.options.slice();
      idInput.value = v.id;
      renderPrice();
      renderAtc();
      renderPickers();
      if (window.history && history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* old browser */ }
      }
      if (!opts.fromPhoto && v.media) showMedia(v.media);
    }

    /* ---------- price + buttons ---------- */

    var priceEl = root.querySelector('[data-skp-price]');
    var compareEl = root.querySelector('[data-skp-compare]');
    var saveEl = root.querySelector('[data-skp-save]');
    var oosEl = root.querySelector('[data-skp-oos]');
    var atcButtons = root.querySelectorAll('[data-skp-atc]');

    function renderPrice() {
      var sale = current.compare > current.price;
      priceEl.textContent = money(current.price);
      priceEl.classList.toggle('is-sale', sale);
      compareEl.hidden = !sale;
      saveEl.hidden = !sale;
      if (sale) {
        compareEl.textContent = money(current.compare);
        saveEl.textContent = 'Save ' + Math.round(((current.compare - current.price) / current.compare) * 100) + '%';
      }
    }

    function renderAtc() {
      var ok = current.available;
      if (oosEl) oosEl.hidden = ok;
      if (busy || addedTimer) return;
      each(atcButtons, function (btn) {
        btn.disabled = !ok;
        btn.classList.remove('is-added', 'is-busy');
        var label = btn.querySelector('[data-skp-atc-label]');
        label.textContent = ok ? 'Add to Cart — ' + money(current.price * qty) : 'Sold out';
      });
      renderQty();
    }

    /* ---------- quantity ---------- */

    function renderQty() {
      qtyInput.value = qty;
      each(root.querySelectorAll('[data-skp-qty]'), function (box) {
        box.querySelector('[data-skp-qty-value]').textContent = qty;
        box.querySelector('[data-skp-qty-minus]').disabled = !current.available || qty <= 1;
        box.querySelector('[data-skp-qty-plus]').disabled = !current.available || qty >= MAX_QTY;
      });
    }

    function setQty(n) {
      qty = Math.max(1, Math.min(MAX_QTY, n));
      renderAtc();
      renderQty();
    }

    each(root.querySelectorAll('[data-skp-qty]'), function (box) {
      box.querySelector('[data-skp-qty-minus]').addEventListener('click', function () { setQty(qty - 1); });
      box.querySelector('[data-skp-qty-plus]').addEventListener('click', function () { setQty(qty + 1); });
    });

    /* ---------- add to cart ---------- */

    function addToCart(trigger) {
      if (busy || !current.available) return;
      if (!(window.SK.cart && typeof window.SK.cart.add === 'function')) {
        form.submit();
        return;
      }
      busy = true;
      clearTimeout(addedTimer);
      addedTimer = 0;
      each(atcButtons, function (btn) {
        btn.disabled = true;
        btn.classList.add('is-busy');
        btn.querySelector('[data-skp-atc-label]').innerHTML =
          '<span style="display:inline-flex;align-items:center;gap:.5rem"><span class="skp-atc__spin"></span>Adding...</span>';
      });
      window.SK.cart.add(current.id, qty, trigger).then(function () {
        busy = false;
        each(atcButtons, function (btn) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          btn.querySelector('[data-skp-atc-label]').textContent = '✓ Added to Cart';
        });
        addedTimer = setTimeout(function () {
          addedTimer = 0;
          renderAtc();
        }, 2000);
      }, function () {
        busy = false;
        renderAtc();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(e.submitter || form.querySelector('[data-skp-atc]'));
    });
    var barAtc = root.querySelector('[data-skp-bar-atc]');
    if (barAtc) barAtc.addEventListener('click', function () { addToCart(barAtc); });

    /* ---------- photos ---------- */

    var slides = root.querySelectorAll('[data-skp-slide]');
    var thumbs = root.querySelectorAll('[data-skp-thumb]');
    var thumbList = root.querySelector('[data-skp-thumbs]');
    var track = root.querySelector('[data-skp-track]');
    var trackSlides = track ? track.children : [];
    var dots = root.querySelectorAll('[data-skp-dot]');
    var main = root.querySelector('[data-skp-main]');
    var mediaIds = Array.prototype.map.call(slides.length ? slides : trackSlides, function (el) {
      return el.getAttribute('data-media-id');
    });
    var count = mediaIds.length;
    var index = 0;
    each(slides, function (el, i) { if (el.classList.contains('is-active')) index = i; });

    function keepThumbVisible(thumb) {
      if (!thumbList || !thumb) return;
      var top = thumb.offsetTop;
      var bottom = top + thumb.offsetHeight;
      if (top < thumbList.scrollTop) thumbList.scrollTop = top - 2;
      else if (bottom > thumbList.scrollTop + thumbList.clientHeight) thumbList.scrollTop = bottom - thumbList.clientHeight + 2;
    }

    function scrollTrack(i, instant) {
      if (!track) return;
      var left = i * track.clientWidth;
      if (Math.abs(track.scrollLeft - left) < 2) return;
      if (instant || reduceMotion || !track.scrollTo) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
    }

    // opts.fromVariant: the variant changed (don't pick a variant back); opts.fromSwipe: the track moved.
    function showIndex(i, opts) {
      if (!count) return;
      opts = opts || {};
      i = ((i % count) + count) % count;
      index = i;
      each(slides, function (el, n) {
        el.classList.toggle('is-active', n === i);
        if (n === i) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      });
      each(thumbs, function (el, n) {
        el.classList.toggle('is-active', n === i);
        if (n === i) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
      keepThumbVisible(thumbs[i]);
      each(dots, function (el, n) { el.classList.toggle('is-active', n === i); });
      if (!opts.fromSwipe) scrollTrack(i, opts.instant);
      if (!opts.fromVariant) photoPicksVariant(mediaIds[i]);
    }

    function showMedia(mediaId) {
      var i = mediaIds.indexOf(String(mediaId));
      if (i >= 0 && i !== index) showIndex(i, { fromVariant: true });
    }

    function photoPicksVariant(mediaId) {
      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (String(v.media) !== String(mediaId)) return;
        var score = 0;
        v.options.forEach(function (o, i) { if (o === selected[i]) score += 2; });
        if (v.available) score += 1;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (best && best !== current) applyVariant(best, { fromPhoto: true });
    }

    each(thumbs, function (el) {
      el.addEventListener('click', function () { showIndex(parseInt(el.getAttribute('data-index'), 10)); });
    });
    each(dots, function (el) {
      el.addEventListener('click', function () { showIndex(parseInt(el.getAttribute('data-index'), 10)); });
    });
    var prev = root.querySelector('[data-skp-prev]');
    var next = root.querySelector('[data-skp-next]');
    if (prev) prev.addEventListener('click', function () { showIndex(index - 1); });
    if (next) next.addEventListener('click', function () { showIndex(index + 1); });

    if (track) {
      var settle = 0;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          if (!track.clientWidth) return;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index && i >= 0 && i < count) showIndex(i, { fromSwipe: true });
        }, 120);
      }, { passive: true });
      // The width changes with the window (e.g. rotating a phone): stay on the same photo.
      window.addEventListener('resize', function () { scrollTrack(index, true); });
    }

    // Desktop: zoom in where the mouse is.
    if (main && slides.length && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      main.addEventListener('mousemove', function (e) {
        var rect = main.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        main.style.setProperty('--skp-zoom-origin', x.toFixed(1) + '% ' + y.toFixed(1) + '%');
        main.classList.add('is-zoomed');
      });
      main.addEventListener('mouseleave', function () {
        main.classList.remove('is-zoomed');
        main.style.removeProperty('--skp-zoom-origin');
      });
    }

    /* ---------- variant picker (photo tiles / pills, styles in sk-quick-add.css) ---------- */

    var optionBoxes = root.querySelectorAll('[data-skp-option]');
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // For option `index` = `value`, the variant a shopper would get (the other options kept when possible).
    function variantFor(index, value) {
      var opts = selected.slice();
      opts[index] = value;
      return exact(opts) || closest(index, value);
    }

    // The first option box (the colour, see sk-product.liquid) is the primary choice: a colour is only crossed
    // out when it is sold out in every size. The other options are crossed out per the chosen colour.
    var primaryIndex = optionBoxes.length ? parseInt(optionBoxes[0].getAttribute('data-option-index'), 10) : 0;

    function renderPickers() {
      each(optionBoxes, function (box) {
        var oi = parseInt(box.getAttribute('data-option-index'), 10);
        box.querySelector('[data-skp-option-value]').textContent = selected[oi];
        var group = box.querySelector('[role="radiogroup"]');
        each(group.querySelectorAll('[role="radio"]'), function (r) {
          var value = r.getAttribute('data-value');
          var ex, oos;
          if (oi === primaryIndex) {
            var withValue = variants.filter(function (x) { return x.options[oi] === value; });
            ex = withValue.filter(function (x) { return x.available; })[0] || withValue[0] || null;
            oos = !(ex && ex.available);
          } else {
            // Crossed out when this value does not exist with the chosen colour (44 EU in White when White
            // only comes in 43), or when that exact variant is sold out. Clicking still picks the nearest variant.
            var opts = selected.slice();
            opts[oi] = value;
            ex = exact(opts);
            oos = !(ex && ex.available);
          }
          var v = (oi === primaryIndex ? null : ex) || variantFor(oi, value);
          var isTile = r.classList.contains('skv-tile');
          r.setAttribute('aria-checked', value === selected[oi] ? 'true' : 'false');
          r.classList.toggle('is-oos', oos);
          r.setAttribute('aria-label', value + (!ex ? ' (not available with the selected options)' : oos ? ' (sold out)' : ''));
          var badge = isTile ? r.querySelector('.skv-tile__oos') : null;
          if (badge) badge.textContent = ex ? 'Sold out' : 'Not available';
          var img = isTile ? r.querySelector('.skv-tile__img img') : null;
          if (isTile && v && v.img) {
            if (!img) {
              img = document.createElement('img');
              img.alt = '';
              img.width = 96;
              img.height = 96;
              var holder = r.querySelector('.skv-tile__img');
              holder.insertBefore(img, holder.firstChild);
            }
            if (img.getAttribute('src') !== v.img) {
              img.removeAttribute('srcset');
              img.setAttribute('src', v.img);
            }
          }
        });
        if (window.SK.radioTabStops) window.SK.radioTabStops(group);
      });
    }

    // Computers: hovering a photo tile previews its photo in the main gallery.
    function previewMedia(mediaId) {
      var i = mediaIds.indexOf(String(mediaId));
      if (i < 0) return;
      each(slides, function (el, n) { el.classList.toggle('is-active', n === i); });
    }

    function endPreview() {
      each(slides, function (el, n) { el.classList.toggle('is-active', n === index); });
    }

    each(optionBoxes, function (box) {
      var oi = parseInt(box.getAttribute('data-option-index'), 10);
      var group = box.querySelector('[role="radiogroup"]');
      group.addEventListener('click', function (e) {
        var r = e.target.closest('[role="radio"]');
        if (r) chooseOption(oi, r.getAttribute('data-value'));
      });
      if (window.SK.radioKeys) {
        window.SK.radioKeys(group, function (r) { chooseOption(oi, r.getAttribute('data-value')); });
      }
      if (canHover && slides.length && group.classList.contains('skv-tiles')) {
        group.addEventListener('mouseover', function (e) {
          var r = e.target.closest('[role="radio"]');
          var v = r ? variantFor(oi, r.getAttribute('data-value')) : null;
          if (v && v.media) previewMedia(v.media);
        });
        group.addEventListener('mouseleave', endPreview);
      }
      var search = box.querySelector('[data-skp-search]');
      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          var shown = 0;
          each(group.querySelectorAll('[role="radio"]'), function (r) {
            var hide = !!q && r.getAttribute('data-value').toLowerCase().indexOf(q) === -1;
            r.hidden = hide;
            if (!hide) shown += 1;
          });
          box.querySelector('[data-skp-search-empty]').hidden = shown > 0;
          if (window.SK.radioTabStops) window.SK.radioTabStops(group);
        });
      }
    });

    // Fill the tiles' photos and the stock marks for the starting variant.
    renderPickers();

    initTabsAndReviews(root);
  }

  /* ================= Tabs (Description | Reviews) + reviews ================= */

  var RATING_WORDS = ['Poor', 'Fair', 'Good', 'Very good', 'Excellent'];

  function initTabsAndReviews(root) {
    var box = root.querySelector('[data-skp-tabs]');
    if (!box) return;
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-skp-tab]'));

    function selectTab(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-skp-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      each(box.querySelectorAll('[data-skp-panel]'), function (p) {
        p.hidden = p.getAttribute('data-skp-panel') !== name;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-skp-tab')); });
      t.addEventListener('keydown', function (e) {
        var to = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault();
        selectTab(tabs[(to + tabs.length) % tabs.length].getAttribute('data-skp-tab'), true);
      });
    });

    var panel = box.querySelector('[data-skp-panel="reviews"]');
    if (!panel) return;

    var count = 0;
    var openBtn = panel.querySelector('[data-skp-review-open]');
    var wrap = panel.querySelector('[data-skp-rf-wrap]');
    var form = panel.querySelector('[data-skp-rf]');
    var done = panel.querySelector('[data-skp-rf-done]');
    var empty = panel.querySelector('[data-skp-reviews-empty]');

    function showReviews(scroll) {
      selectTab('reviews');
      if (scroll) box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    /* --- numbers from Judge.me's widget (rendered with the page): average, count, 5 → 1 breakdown --- */
    function renderNumbers() {
      var w = panel.querySelector('.jdgm-rev-widg');
      if (!w) return;
      var avg = parseFloat(w.getAttribute('data-average-rating')) || 0;
      count = parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0;
      var label = count ? 'Rated ' + avg.toFixed(1) + ' out of 5' : 'No ratings yet';
      each(root.querySelectorAll('[data-skp-stars]'), function (s) {
        s.style.setProperty('--sk-stars-fill', (count ? Math.min(100, (avg / 5) * 100) : 0) + '%');
        s.setAttribute('aria-label', label);
      });
      var avgEl = panel.querySelector('[data-skp-avg]');
      if (avgEl) avgEl.textContent = count ? avg.toFixed(1) : '0.0';
      var based = panel.querySelector('[data-skp-based]');
      if (based) based.textContent = count ? 'Based on ' + count + (count === 1 ? ' review' : ' reviews') : 'No reviews yet';
      var tabCount = box.querySelector('[data-skp-review-count]');
      if (tabCount) tabCount.textContent = '(' + count + ')';
      var text = root.querySelector('[data-skp-rating-text]');
      if (text) {
        if (count) text.textContent = avg.toFixed(1) + ' · ' + count + (count === 1 ? ' review' : ' reviews');
        else text.innerHTML = 'No reviews yet · <span class="skp-rating__cta">Write the first</span>';
      }
      var freq = {};
      each(w.querySelectorAll('.jdgm-histogram__row[data-rating]'), function (r) {
        freq[r.getAttribute('data-rating')] = {
          n: parseInt(r.getAttribute('data-frequency'), 10) || 0,
          pct: parseFloat(r.getAttribute('data-percentage')) || 0
        };
      });
      each(panel.querySelectorAll('.skp-hist__row'), function (r) {
        var f = freq[r.getAttribute('data-rating')] || { n: 0, pct: 0 };
        r.querySelector('.skp-hist__fill').style.width = f.pct + '%';
        r.querySelector('.skp-hist__n').textContent = f.n;
      });
      if (empty && wrap.hidden) empty.hidden = count > 0;
    }
    renderNumbers();
    setTimeout(renderNumbers, 2500); // in case Judge.me refreshes its widget after loading

    // Review cards: the avatar shows the reviewer's initial (Judge.me re-renders on sort / next page).
    var list = panel.querySelector('[data-skp-jdgm]');
    function decorate() {
      each(list.querySelectorAll('.jdgm-rev'), function (rev) {
        var icon = rev.querySelector('.jdgm-rev__icon');
        var author = rev.querySelector('.jdgm-rev__author');
        if (!icon || icon.hasAttribute('data-sk-initial')) return;
        var name = author ? author.textContent.trim() : '';
        icon.setAttribute('data-sk-initial', (name.charAt(0) || '?').toUpperCase());
        icon.setAttribute('aria-hidden', 'true');
      });
    }
    if (list) {
      decorate();
      new MutationObserver(decorate).observe(list, { childList: true, subtree: true });
    }

    /* --- links to the reviews: the rating under the title, #reviews, Judge.me's email links --- */
    var link = root.querySelector('[data-skp-rating-link]');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        showReviews(true);
        if (!count) openForm(); // no reviews yet: straight to the form, focus on the stars
      });
    }
    function fromHash() {
      if (/^#(reviews|judgeme_product_reviews)$/.test(window.location.hash)) showReviews(true);
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);

    if (!form) return;

    /* --- the review form, in place --- */
    var starsBox = form.querySelector('[data-skp-rf-stars]');
    var stars = starsBox.querySelectorAll('.skp-rf__star');
    var word = form.querySelector('[data-skp-rf-word]');
    var status = form.querySelector('[data-skp-rf-status]');
    var submit = form.querySelector('[data-skp-rf-submit]');
    var rating = 0;
    var busy = false;

    function paint(n) {
      each(stars, function (s, i) { s.classList.toggle('is-on', i < n); });
      word.textContent = n ? RATING_WORDS[n - 1] : 'Tap a star';
      word.classList.toggle('is-empty', !n);
    }
    function setRating(n) {
      rating = n;
      each(stars, function (s, i) { s.setAttribute('aria-checked', i === n - 1 ? 'true' : 'false'); });
      if (window.SK.radioTabStops) window.SK.radioTabStops(starsBox);
      paint(n);
      if (n) showError('rating', false);
    }
    each(stars, function (s) {
      var n = parseInt(s.getAttribute('data-value'), 10);
      s.addEventListener('click', function () { setRating(n); });
      s.addEventListener('mouseenter', function () { paint(n); });
    });
    starsBox.addEventListener('mouseleave', function () { paint(rating); });
    if (window.SK.radioKeys) {
      window.SK.radioKeys(starsBox, function (s) { setRating(parseInt(s.getAttribute('data-value'), 10)); });
    }
    paint(0);

    function showError(name, on) {
      var msg = form.querySelector('[data-skp-rf-error="' + name + '"]');
      if (msg) msg.hidden = !on;
      var field = name === 'rating' ? starsBox : form.elements[name];
      if (field) field.setAttribute('aria-invalid', on ? 'true' : 'false');
    }
    ['body', 'name', 'email'].forEach(function (name) {
      form.elements[name].addEventListener('input', function () { showError(name, false); });
    });

    function values() {
      return {
        title: form.elements.title.value.trim(),
        body: form.elements.body.value.trim(),
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim()
      };
    }

    function validate(v) {
      var bad = [];
      if (!rating) bad.push('rating');
      if (v.body.length < 10) bad.push('body');
      if (!v.name) bad.push('name');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) bad.push('email');
      ['rating', 'body', 'name', 'email'].forEach(function (n) { showError(n, bad.indexOf(n) !== -1); });
      if (bad.length) {
        var first = bad[0] === 'rating' ? starsBox.querySelector('[tabindex="0"]') : form.elements[bad[0]];
        if (first) first.focus();
      }
      return !bad.length;
    }

    function openForm(focus) {
      wrap.hidden = false;
      form.hidden = false;
      done.hidden = true;
      if (empty) empty.hidden = true;
      openBtn.setAttribute('aria-expanded', 'true');
      if (focus !== false) {
        var first = starsBox.querySelector('[tabindex="0"]');
        if (first) first.focus({ preventScroll: true });
        wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      }
    }
    function closeForm() {
      wrap.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      if (empty) empty.hidden = count > 0;
      openBtn.focus();
    }
    openBtn.addEventListener('click', function () {
      if (wrap.hidden || form.hidden) openForm();
      else closeForm();
    });
    form.querySelector('[data-skp-review-cancel]').addEventListener('click', closeForm);

    // Sent like Judge.me's own form: POST api.judge.me/api/v1/reviews (multipart), no secret key.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var v = values();
      if (!validate(v)) return;
      busy = true;
      status.hidden = true;
      submit.disabled = true;
      submit.innerHTML = '<span class="skp-atc__spin"></span>Sending…';
      var shop = form.getAttribute('data-shop');
      var data = new FormData();
      data.append('url', shop);
      data.append('shop_domain', shop);
      data.append('platform', 'shopify');
      data.append('rating', String(rating));
      data.append('name', v.name);
      data.append('email', v.email);
      data.append('body', v.body);
      if (v.title) data.append('title', v.title);
      data.append('id', form.getAttribute('data-product-id'));
      fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: data })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          form.hidden = true;
          done.hidden = false;
          done.focus();
          form.elements.title.value = '';
          form.elements.body.value = '';
          setRating(0);
          openBtn.setAttribute('aria-expanded', 'false');
        })
        .catch(function () {
          status.textContent = "We couldn't send your review. Please check your connection and try again.";
          status.hidden = false;
        })
        .then(function () {
          busy = false;
          submit.disabled = false;
          submit.textContent = 'Submit review';
        });
    });
  }

  function initAllProducts() {
    each(document.querySelectorAll('[data-sk-product]'), initProduct);
  }

  /* ================= Empire product section: photo -> variant ================= */

  function readVariants(root) {
    var el = root.querySelector('script[data-sk-variant-media]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // The value chosen for each option, in order (Empire renders radios or a select per option).
  function currentOptions(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-variant-option]'), function (optionEl) {
      if (optionEl.tagName === 'SELECT') return optionEl.value;
      var checked = optionEl.querySelector('input[data-variant-option-value]:checked');
      return checked ? checked.value : null;
    });
  }

  function chooseEmpireOption(root, index, value) {
    var optionEl = root.querySelector('[data-variant-option][data-variant-option-index="' + index + '"]');
    if (!optionEl) return;
    if (optionEl.tagName === 'SELECT') {
      optionEl.value = value;
      optionEl.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var inputs = optionEl.querySelectorAll('input[data-variant-option-value]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        inputs[i].click();
        return;
      }
    }
  }

  function bindGallery(gallery) {
    if (gallery.skBound) return;
    var root = gallery.closest('.product--outer');
    var viewer = gallery.querySelector('[data-swiper-viewer]');
    var variants = root && viewer ? readVariants(root) : null;
    if (!variants || variants.length < 2) return;
    gallery.skBound = true;

    // The photo already shown when this runs (Swiper may have started first), else the first one marked.
    var startActive = viewer.querySelector('.swiper-slide-active');
    var shownMedia = startActive ? startActive.getAttribute('data-media-id') : null;
    var applying = false;

    function onPhotoShown(mediaId) {
      var matching = variants.filter(function (v) {
        return String(v.media) === mediaId;
      });
      if (!matching.length) return;

      var current = currentOptions(root);
      var best = null;
      var bestSame = -1;
      matching.forEach(function (v) {
        var same = v.options.filter(function (value, i) {
          return value === current[i];
        }).length;
        if (same > bestSame) {
          best = v;
          bestSame = same;
        }
      });
      if (bestSame === best.options.length) return; // already the chosen variant

      // Each option change makes Empire update the variant and slide to its photo: ignore those slides.
      applying = true;
      best.options.forEach(function (value, i) {
        if (value !== current[i]) chooseEmpireOption(root, i, value);
      });
      setTimeout(function () {
        applying = false;
        var active = viewer.querySelector('.swiper-slide-active');
        shownMedia = active ? active.getAttribute('data-media-id') : shownMedia;
      }, 100);
    }

    // Swiper marks the shown photo with .swiper-slide-active (also after Empire resizes / rebuilds it).
    new MutationObserver(function () {
      var active = viewer.querySelector('.swiper-slide-active');
      if (!active) return;
      var mediaId = active.getAttribute('data-media-id');
      if (mediaId === shownMedia) return;
      var first = shownMedia === null;
      shownMedia = mediaId;
      if (!first && !applying) onPhotoShown(mediaId);
    }).observe(viewer, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function bindAllGalleries() {
    each(document.querySelectorAll('.product--outer product-gallery'), bindGallery);
  }

  /* ================= Instagram share ================= */

  function note(button, text) {
    var list = button.closest('.share-buttons');
    if (!list) return;
    var el = list.querySelector('.sk-share-note');
    if (!el) {
      el = document.createElement('span');
      el.className = 'sk-share-note';
      el.setAttribute('role', 'status');
      list.appendChild(el);
    }
    el.textContent = text;
    clearTimeout(el.skTimer);
    el.skTimer = setTimeout(function () {
      el.textContent = '';
    }, 4000);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-sk-share-instagram]');
    if (!button) return;
    e.preventDefault();
    var url = button.getAttribute('data-url') || window.location.href;
    var title = button.getAttribute('data-title') || document.title;
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    if (touch && navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var copied = function () {
      note(button, 'Link copied. Paste it in Instagram.');
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(copied, function () {
        window.prompt('Copy this link and paste it in Instagram:', url);
      });
    } else {
      window.prompt('Copy this link and paste it in Instagram:', url);
    }
  });

  function start() {
    initAllProducts();
    bindAllGalleries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: re-init a re-rendered section.
  document.addEventListener('shopify:section:load', function (e) {
    each(e.target.querySelectorAll('[data-sk-product]'), initProduct);
  });
})();
